import React, { useState, useEffect } from 'react';
import OrderTemplate from "./OrderTemplate";
import { useUser } from '../../../../UserContext';
import { setOrderStatus } from '../../../API_Handler';
import MessagesComponent from '../Messages/Messages'; // Import your MessagesComponent
import './Orders.css';
import { useToast } from '../../../../Common/ToastContext';
import SearchBar from "../SearchBar/SearchBar";


const Orders = () => {
    const showToast = useToast();
    const { userOrders, setUserOrders } = useUser();
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]); // To store filtered orders
    const [isMessagePanelOpen, setIsMessagePanelOpen] = useState(false); // Modal-like state
    const [selectedOrder, setSelectedOrder] = useState(null); // Currently selected order
    const [searchQuery, setSearchQuery] = useState(''); // Search query state
    const [selectedStatus, setSelectedStatus] = useState(''); // State for selected status
    const [screenLoading, setScreenLoading] = useState(false);

    // Function to handle the opening of the custom message modal
    const handleOpenMessagePanel = (order) => {
        setSelectedOrder(order);
        setIsMessagePanelOpen(true); // Open the panel
    };

    // Function to handle the closing of the custom message modal
    const handleCloseMessagePanel = () => {
        setIsMessagePanelOpen(false); // Close the panel
    };

    // Function to handle search input
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        applyFilters(query, selectedStatus); // Apply filters when search changes
    };

    // Function to handle status selection
    const handleStatusChange = (e) => {
        const status = e.target.value;
        setSelectedStatus(status);
        applyFilters(searchQuery, status); // Apply filters when status changes
    };

    // Function to apply search and status filters
    const applyFilters = (query, status) => {
        const filtered = orders.filter(
            (order) =>
                (order.id?.toLowerCase().includes(query) || order.user_email?.toLowerCase().includes(query) || order.practice_user_email?.toLowerCase().includes(query)) &&
                (status === '' || order.status === status) // Filter by status if a status is selected
        );
        setFilteredOrders(filtered);
    };

    const updateOrderStatus = async (orderId, action) => {

        const confirmation = window.confirm(`Are you sure you want to ${action} this order?`);
        if (!confirmation) return;

        let response = null;
        if (action === 'reopen') {
            response = await setOrderStatus(orderId, 'AWAITING VENDOR ACTION', showToast, true);
        } else if (action === 'close') {
            response = await setOrderStatus(orderId, 'CLOSED', showToast, true);
        }

        // This updates the orders with the new order, without having to re-fetch
        const updatedOrders = userOrders.map((item) =>
            item.id === response.id ? response : item
        );
        setUserOrders(updatedOrders);
    };

    useEffect(() => {
        if (userOrders) {
            setOrders(userOrders);
            setFilteredOrders(userOrders);
            return;
        }
    }, [userOrders]);

    // console.log(orders)

    return (
        <div className="mt-[20px] flex flex-col">
            {/* Search Bar and Status Filter */}
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center">
                {/* Search Bar */}
                <SearchBar handleSearch={handleSearch} text={"Search your orders"} />
                {/* Status Filter */}
                <div className="w-full h-[40px] flex justify-end mt-[20px] lg:mt-0">
                    <select
                        className="w-[208px] h-[40px] text-white px-2 py-auto text-[18px] bg-charmOrange hover:text-integrationRequestTextHover hover:bg-charmHover font-proximanova whitespace-nowrap"
                        value={selectedStatus} // Bind the selected status
                        onChange={handleStatusChange} // Handle status change
                    >
                        <option value="">All Statuses</option>
                        <option value="PENDING">Pending</option>
                        <option value="AWAITING USER ACTION">Awaiting User Action</option>
                        <option value="AWAITING VENDOR ACTION">Awaiting Vendor Action</option>
                        <option value="CLOSED">Closed</option>
                        <option value="LEGACY">Legacy</option>
                    </select>
                </div>
            </div>

            {screenLoading ? (
                <div className="flex items-center justify-center h-screen">
                    <div className="spinner-border text-black" role="status">
                    </div>
                </div>
            ) : (
                <div>
                    {/* Orders List */}
                    {filteredOrders.length === 0 ? (
                        <p className="mt-20 text-center text-[18px] font-proximanova text-[#505050]">No orders match your search.</p>
                    ) : (
                        <div className="flex flex-wrap mt-6 w-full  justify-start overflow-y-auto relative">
                            {filteredOrders.map((order) => (
                                <OrderTemplate key={order.id} order={order} handleOpenMessagePanel={handleOpenMessagePanel} updateOrderStatus={updateOrderStatus} />
                            ))}
                        </div>
                    )}

                    {/* Custom Modal-Like Overlay */}
                    {isMessagePanelOpen && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                {/* Insert MessagesComponent */}
                                <MessagesComponent selectedOrder={selectedOrder} handleCloseMessagePanel={handleCloseMessagePanel} />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Orders;
